import React from "react";
import ReactTable from "react-table";

import Pagination from "./RTPagination";

const PaginatedTable = ({ data = [], columns = [], pageSize, totalItems = null, next, prev, onPagination, className = "", noEmpty = false, emptyMessage="No rows found!" }) => {
	const onChange = (field, value) => {
		onPagination(value.split("?")[1]);
	};

	return data.length ? (
		<div className="table-container table-with-pagination">
			<ReactTable
				data={data}
				columns={columns}
				minRows="0"
				className={className ? className : "table-default"}
				showPagination={false}
				pageSize={pageSize ? pageSize : data.length}
			/>
			<Pagination onPageChange={onChange} pageSize={pageSize ? pageSize : data.length} totalCount={totalItems ? totalItems : data.length} next={next} prev={prev} />
		</div>) : (	
			<>
				{noEmpty ? (
					<div className="alert alert-danger text-center p-3 mt-4">{emptyMessage}</div>
				): (
					<div className="alert alert-info text-center p-3 mt-4">{emptyMessage}</div>
				)}
			</>
		);
};

export default PaginatedTable;
